import { useNavigate } from 'react-router';
import useAuth from './UseAuth';
import { useEffect } from 'react';
import Spinner from '../../views/spinner/Spinner';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();  // Check if auth state is initialized
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized) {
      if (!isAuthenticated) {
        navigate('/auth/login', { replace: true });
      }
    }
  }, [isAuthenticated, isInitialized, navigate]);

  if (!isInitialized) {
    return <Spinner/>;  // Show a loading screen until the auth state is checked
  }

  return children;  // Render children protected pages if authenticated and initialized
};

export default AuthGuard;
